<template>
  <span>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-toolbar
            color="#286090"
            dark
          >
            <img src="@/assets/logo_nuevo.png"style="width:50px;height:51px" class="mr-4">
          	<h2 v-if="status == 11">ASIGNAR TOCA A PONENCIA</h2>
          	<h2 v-if="status == 30">ASIGNAR TOCA AL RELATOR </h2>
        	</v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <h2 class="mb-2">TOCA:
                    {{ item.toca.numero }}/{{ item.toca.anio }}
                    <span v-if="item.toca.complemento">
                    -{{ item.toca.complemento }}
                  </span>
                  <span v-if="item.returno == 1" style="color:red">(RETURNO) </span></h2>
                  <!-- <h2 class="mb-2">EXPEDIENTE: {{ item.expediente }} </h2> -->
                  <!-- <h3 class="mb-6" style="color:red" v-if="item.ponencia_data && status == 20">(PONENCIA ACTUAL: {{ item.ponencia_data.magistrado.toUpperCase()}})</h3> -->
                  <!-- :item-text=" item => item.nombre + ' (' + item.magistrado.nombre + ' ' + item.magistrado.primer_apellido + ')' " -->
                  <!-- <v-alert
                    v-if="item.status== 20 && item.excusas.length"
                    outlined
                    color="red"
                  >
                    <h4 class="mb-2">MAGISTRADO CON EXCUSA:</h4>
                    <span v-for="(excusa, i) in item.excusas" :key="i">
                      <li>{{ excusa.nombre_magistrado_excusado }}</li>
                    </span>
                  </v-alert> -->
                  <v-autocomplete
                  	v-if="status == 11"
                    class="mt-8"
                    outlined
                    label="Seleccione una ponencia"
                    :item-text=" item => item.magistrado"
                    item-value="id"
                    persistent-hint
                    :items = "ponencias"
                    v-model="ponencia_selected"
                    :rules="[v => !!v || 'Campo requerido']"
                    required
                  />
                   <v-autocomplete
                  	v-if="status == 30"
                    class="mt-4"
                    outlined
                    label="Seleccione un relator"
                    :item-text="item =>
                    	item.nombre + ' ' +
                    	item.primer_apellido + ' ' +
                    	(item.segundo_apellido ? item.segundo_apellido : '')
                    "
                    item-value="id"
                    persistent-hint
                    :items = "relatores"
                    v-model="relator_selected"
                    :rules="[v => !!v || 'Campo requerido']"
                    required
                  />
                </v-col>
                <!-- <v-col v-if="status == 11" cols="12" md="6" class="mt-n4">
                  <v-menu
                    v-model="menu_fecha_citacion"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fecha_citacion"
                        label="Fecha de Citacion"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                        :rules="[rules.required]"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fecha_citacion"
                      @input="menu_fecha_citacion = false"
                      locale="es-mx"
                      :max="today"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col> -->
                <v-col v-if="status == 11" cols="12" class="mt-n4">
                  <v-menu
                    v-model="menu_fecha_turno"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fecha_turno"
                        label="Fecha de Turno"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                        :rules="[rules.required]"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fecha_turno"
                      @input="menu_fecha_turno = false"
                      locale="es-mx"
                      :max="today"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mb-2"
              color="red darken-1"
              text
              @click="$emit('closeModal')"
            >
              Cerrar
            </v-btn>
            <v-btn
              class="mb-2"
            	v-if="status == 11"
              color="green darken-1"
              text
              @click="asignar()"
              :disabled="!valid"
              :loading="loading"
            >
              Asignar ponencia
            </v-btn>
            <v-btn
              class="mb-2"
            	v-if="status == 30"
              color="green darken-1"
              text
              @click="asignar()"
              :disabled="!valid"
              :loading="loading"
            >
              Asignar RELATOR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
  </span>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      status: {
        type: Number,
        required: true
      },
      ponencias: {
        type: Array,
        required: true
      },
      relatores: {
        type: Array,
        required: true
      },
    },
    data: () => ({
      dialog:false,
      valid: false,
      loading: false,
      ponencia_selected: '',
      relator_selected: '',
      ponencias_sin_excusas:'',
      menu_fecha_turno: false,
      menu_fecha_citacion: false,
      fecha_citacion: "",
      fecha_turno: "",
      today: '',
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    mounted(){
      var d = new Date();
      var mm = d.getMonth() + 1;
      if (mm<10) {
        mm = '0'+ mm
      }
      var dd = d.getDate();
      if (dd<10) {
        dd = '0'+ dd
      }
      var yy = d.getFullYear();
      this.today = yy + '-' + mm + '-' + dd;
      this.fecha_cuenta = yy + '-' + mm + '-' + dd;
      // SI TIENE EXCUSAS, QUITAMOS MAGISTRADOS DEL LISTADO
      // this.item.toca.excusas.forEach(function(item_excusa){
      //   this.ponencias.forEach(function(item, index, object) {
      //     if (item.user_id === item_excusa.mag_excusado) {
      //       this.ponencias.splice(index, 1);
      //     }
      //   }.bind(this))
      // }.bind(this));
    },
    methods:{
      asignar(){
        this.loading = true;
        if (this.status == 11) {
          this.url = "/asignar-ponencia/" + this.item.toca_id
          this.datos = {
            ponencia_id: this.ponencia_selected,
            apelacion_id: this.item.id,
            fecha_citacion: this.fecha_citacion,
            fecha_turno: this.fecha_turno,
          }
        }
        if (this.status == 30) {
          this.url = "/asignar-relator/" + this.item.id
          this.datos = {
            toca_id: this.item.toca_id,
            apelacion_id: this.item.id,
            relator_id: this.relator_selected,
            magistrado_id: this.item.toca.ponencia.user_id,
            ponencia_id: this.item.toca.ponencia_id
          }
        }
    	  this.$store.dispatch("UPDATE_TOCA", { url: this.url, data: this.datos }).then(response => {
          let textSwal = this.status == 11 ? 'Ponencia asignada correctamente.' : 'Relator asignado correctamente.'
    	  	if (response.data.status == "ok") {
	    	  	this.$swal({
	            title: "Éxito!!!",
	            text: textSwal,
	            icon: "success",
	            confirmButtonText: "Aceptar"
	          });
						this.dialog = false
            this.loading = false;
    	  	}
          this.$emit('reloadTocas');
          this.$emit('closeModal');
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
      },
      cancelar(){
      	this.$refs.form.resetValidation()
      	this.dialog = false,
      	this.ponencia_selected = ''
      	this.relator_selected = ''
      }
    }
  };
</script>
